import React, { useState, useEffect, useMemo } from 'react';
import Modal from '../components/Modal'; // Import the new Modal component
import './WorkPage.css';

// Same approach for images
import cas from './images/temp.webp';
import trixie from './images/Trixie.webp';
import ado_hero from './images/temp3.webp';
import pickard from './images/Pickard-Chilton.webp';
import spark from './images/spark.webp';
import planned from './images/planned-parenthood.webp';
import KTPG from './images/KTPG.webp';
import genetic from './images/genetic.webp';
import ashes from './images/ashes.webp';


const WorkPage = () => {
  const [activeFilter, 
    //setActiveFilter ***UNCOMMENT TO ADD FILTER***
    ] = useState('All');
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [animateCards, setAnimateCards] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  
  // Projects data wrapped in useMemo to avoid recreating on every render
  const projects = useMemo(() => [
    {
      title: "A/D/O: In Practice",
      category: "Branded Documentary Series",
      image: cas,
      description: "For BMW/MINI's design hub in Greenpoint, we crafted four intimate portrait films spotlighting American designers reshaping their industries. Premiering at the Architecture & Design Film Festival, these films were the digital gateway for visitors discovering A/D/O's innovative vision online.",
      videoUrl: "https://player.vimeo.com/video/779759742?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", // Replace with your actual Vimeo URL
    },
    {
      title: "Introducing A/D/O",
      category: "Branded Documentary",
      image: ado_hero,
      description: "For BMW/MINI's design hub in Greenpoint, we created an introductory film showcasing A/D/O as an intersection of innovation and creative exploration. Complementing our portrait series, this documentary captures the vision behind the space through the eyes of its founders, highlighting how A/D/O was designed to transform our approach to design's future.",
      videoUrl: "https://player.vimeo.com/video/779758269?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", // Replace with your actual Vimeo URL
    },
    {
      title: "Pickard Chilton",
      category: "Branded Documentary",
      image: pickard,
      description: "For acclaimed firm Pickard Chilton, we documented the intricate journey from abstract concept to architectural achievement. By following key team members through critical decision points, we highlight the human ingenuity and collaborative spirit that drives their innovative approach to designing spaces that will shape cityscapes for generations.",
      videoUrl: "https://player.vimeo.com/video/814780315?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", // Replace with your actual Vimeo URL
    },
     {
      title: "Walmart: Spark to Shelf",
      category: "Branded Gameshow",
      image: spark,
      description: "For Walmart and Essence Studios, our team created this dynamic docuseries following ambitious entrepreneurs as they compete for valuable shelf space in the world's largest retailer. Produced during the height of the pandemic using innovative remote production techniques, we overcame logistical challenges to craft engaging content that balances compelling personal narratives with the high-stakes business challenge, showcasing the journey from passionate vision to national brand.",
      videoUrl: "https://player.vimeo.com/video/434932859?app_id=122963&wmode=opaque", // Replace with your actual Vimeo URL
    },
    {
      title: "Planned Parenthood",
      category: "Branded Documentary",
      image: planned,
      description: "Our documentary for Planned Parenthood NYC explores the vital addition of their Queens health center, examining the community needs it addresses and its comprehensive services. Through conversations with healthcare providers and local advocates, we highlight how this facility expands essential care access in one of the most diverse places in the world.",
      videoUrl: "https://player.vimeo.com/video/125463705?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", // Replace with your actual Vimeo URL
    },
      {
      title: "Trixie Mattel: Moving Parts",
      category: "Feature Documentary",
      image: trixie,
      description: "From our team of directors, this intimate documentary follows RuPaul's Drag Race All-Stars winner Trixie Mattel during a pivotal moment in her career. The film, which premiered at the Tribeca Film Festival, offers an unvarnished look behind the makeup as Trixie navigates the highs of stardom and the raw challenges of the entertainment industry.",
      videoUrl: "https://www.youtube.com/embed/g9rUUsnWIDo?si=qHlbT5-TWqXWZM7v", // Replace with your actual Vimeo URL
    },
    {
      title: "Kiss the Past Goodbye",
      category: "Feature Documentary",
      image: KTPG,
      description: "From our team of directors comes a feature documentary exploring the extraordinary yet under-recognized legacy of photographer and filmmaker Danny Seymour. This work-in-progress, with excerpts already showcased at MoMA and The New York Times Magazine, traces Seymour's profound influence on iconic visual artists including Robert Frank, Danny Lyon, and Larry Clark, examining how his bold approach and tragically short career reshaped documentary photography.",
      videoUrl: "https://vp.nyt.com/video/2015/07/03/34280_1_mag-lifeisshort_wg_1080p.mp4", // Replace with your actual Vimeo URL
    },
    {
      title: "Keeper of the Ashes",
      category: "Streaming + Broadcast",
      image: ashes,
      description: "In collaboration with Hulu and ABC News Studios, our team crafted this visually distinctive 4-part docuseries examining a devastating 1970s Oklahoma murder case. Through meticulous archival restoration and thoughtful storytelling, we excavated the complex tensions between communities that both preceded and followed the tragedy, creating a nuanced portrait of a moment that still resonates decades later.",
      videoUrl: "https://www.youtube.com/embed/XmP4-HKlWrk?si=xaglXr2APZJwzkxM", // Replace with your actual Vimeo URL
    },
    {
      title: "The Genetic Detective",
      category: "Streaming + Broadcast",
      image: genetic,
      description: "Our team, in collaboration with ABC News Studios, produced this series that distills the complex science of genetic genealogy into clear, accessible storytelling. By streamlining technical concepts without sacrificing accuracy, we created engaging television that allows viewers to quickly grasp how investigators transform DNA evidence into family trees to solve decades-old cold cases.",
      videoUrl: "https://player.vimeo.com/video/1085011940?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", // Replace with your actual Vimeo URL
    }
  ], []);

  // Define manual filter categories  ***UNCOMMENT TO ADD FILTER***
  // const filterCategories = [
  //   'All', 
  //   'Branded',
  //   'Feature Documentary',
  //   'Streaming + Broadcast',
  //   // 'B2B',
  //   // 'Live Event Coverage'
  // ];

  // Define mapping between display categories and internal categories - using useMemo to avoid recreation
  const categoryMapping = useMemo(() => ({
    'All': ['All'], // Special case, handled separately
    'Branded': ['Branded Documentary', 'Branded Documentary Series', "Branded Gameshow", 'B2B'],
    'Feature Documentary': ['Feature Documentary'],
    'Streaming + Broadcast': ['Streaming + Broadcast'],
    // Add more mappings as needed
  }), []);

  // // Handle filter change   ***UNCOMMENT TO ADD FILTER***
  // const handleFilterChange = (category) => {
  //   setAnimateCards(false);
  //   setTimeout(() => {
  //     setActiveFilter(category);
  //     setAnimateCards(true);
  //   }, 50);
  // };

  // Filter projects based on active filter
  useEffect(() => {
    if (activeFilter === 'All') {
      setFilteredProjects(projects);
    } else {
      // Get the array of internal categories that match the display category
      const internalCategories = categoryMapping[activeFilter] || [];
      
      // Filter projects that match any of the internal categories
      setFilteredProjects(projects.filter(project => 
        internalCategories.some(category => project.category.includes(category))
      ));
    }
  }, [activeFilter, projects, categoryMapping]); // Added missing dependencies here

  // Set initial animation
  useEffect(() => {
    // Short delay to ensure animation runs after initial render
    const timer = setTimeout(() => {
      setAnimateCards(true);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  // Open project modal
  const openProjectModal = (project) => {
    setSelectedProject(project);
  };

  // Close project modal
  const closeProjectModal = () => {
    setSelectedProject(null);
  };

  return (
    <section className="work-section">
      <div className="work-container">
      {/*
        <h2 className="work-title">our work</h2>
        <p className="work-intro">We bring documentary-quality storytelling to branded content, delivering authentic narratives that resonate with audiences.</p>
        <div className="section-spacer"></div>
      */}

        {/* Filter Categories */}
{/*                              ***UNCOMMENT TO ADD FILTER***
        <div className="filter-container">
          <div className="filter-list">
            {filterCategories.map((category, index) => (
              <div key={index} className="filter-item">
                <button 
                  className={`filter-button ${activeFilter === category ? 'active' : ''}`}
                  onClick={() => handleFilterChange(category)}
                >
                  {category}
                </button>
              </div>
            ))}
          </div>
        </div>
*/}
        
        {/* Project Grid */}
        <div className="project-grid">

          {filteredProjects.length > 0 ? (
            filteredProjects.map((project, index) => (

              <div 
                key={index} 
                className={`project-card ${animateCards ? 'animate' : ''}`}
                style={{ '--card-index': index }} 
                onClick={() => openProjectModal(project)}
              >
                <div className="project-image-container">
                  <img 
                    src={project.image} 
                    alt={project.title} 
                    className="project-image"
                  />
                  <div className="project-overlay">
                    <div className="overlay-content">
                      <h3 className="overlay-title">{project.title}</h3>
                      <p className="overlay-category">{project.category}</p>
                    </div>
                  </div>
                </div>
              </div>

            ))
          ) : (
            <div className="no-projects-message">
              <h3>Coming Soon</h3>
              <p>Projects brewing. Check back for fresh additions.</p>
            </div>

          )}
        </div>
      </div>

      {/* Portal-based Modal */}
      <Modal 
        isOpen={!!selectedProject} 
        onClose={closeProjectModal}
      >
        {selectedProject && (
          <div className="modal-content">
            <div className="modal-video">
              <iframe
                src={selectedProject.videoUrl}
                title={selectedProject.title}
                width="100%"
                height="100%"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="modal-info">
              <p className="modal-category">{selectedProject.category}</p>
              <h2 className="modal-title">{selectedProject.title}</h2>
              <p className="modal-description">{selectedProject.description}</p>
            </div>
          </div>
        )}
      </Modal>
    </section>
  );
};

export default WorkPage;